module.exports = __webpack_public_path__ + "img/desklamp.291ffde3.png";